module.exports = __webpack_public_path__ + "bundle/fonts/ComingSoon.ttf";